import { DefaultTheme } from 'styled-components/dist/types';

export type ColorVariant =
  | 'GREEN'
  | 'BLUE'
  | 'PURPLE'
  | 'LIGHT_GREEN'
  | 'LIGHT_BLUE'
  | 'LIGHT_PURPLE';
export const mapColorVariantToBarStyle = (
  colorVariant: ColorVariant,
  theme: DefaultTheme,
): { barColor: string; barLabelColor: string } => {
  switch (colorVariant) {
    case 'GREEN':
      return {
        barColor: theme.palette.graphicGreen,
        barLabelColor: theme.palette.backgroundPrimary,
      };
    case 'LIGHT_GREEN':
      return {
        barColor: theme.palette.backgroundGreen,
        barLabelColor: theme.palette.textGreen,
      };
    case 'BLUE':
      return {
        barColor: theme.palette.graphicBlue,
        barLabelColor: theme.palette.backgroundPrimary,
      };
    case 'LIGHT_BLUE':
      return {
        barColor: theme.palette.backgroundBlue,
        barLabelColor: theme.palette.textBlue,
      };
    case 'PURPLE':
      return {
        barColor: theme.palette.backgroundPurpleStatic,
        barLabelColor: theme.palette.backgroundPrimary,
      };
    case 'LIGHT_PURPLE':
      return {
        barColor: theme.palette.backgroundPurple,
        barLabelColor: theme.palette.textPurple,
      };
  }
};
